import React from "react";
import Link from "next/link";
import TypographyPoppins from "../TypographyPoppins";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";
import { SmallMenuUserIcon } from "../../../public/Theme";
import Image from "next/image";
import { usePathname } from "next/navigation";

const ProfileMenuLoginSignup = ({ setOpen }) => {
    const pathName = usePathname();

    const BoxRoutes = ["styling", "stylist", "style-my-wardrobe"]
    const isBoxRoute = BoxRoutes.some((route) => pathName.includes(route));

    const signupLink =
        isBoxRoute
            ? FRONTEND_ENDPOINTS?.BOX_SIGNUP
            : pathName?.includes("shop")
                ? FRONTEND_ENDPOINTS?.SHOP_SIGNUP
                : FRONTEND_ENDPOINTS?.SIGNUP;

    return (
        <div className="w-full flex gap-[10px] rounded bg-LIGHT_PINK items-center px-5 py-[30px]">
            <div className="w-10 h-10 rounded-full border border-Primary_Default flex items-center justify-center">
                <Image
                    width={20}
                    height={20}
                    src={SmallMenuUserIcon}
                    alt={"avatar icon"}
                />
            </div>
            <div>
                <div className="flex flex-col gap-x-1 gap-y-4">
                    <Link
                        onClick={() => setOpen(false)}
                        testid={`header-profile-menu-signin`}
                        href={FRONTEND_ENDPOINTS?.LOGIN}
                        prefetch
                        className="flex gap-x-2"
                    >
                        <TypographyPoppins
                            text={"Login"}
                            customStyle={"!text-base !font-medium !capitalize !underline"}
                        />
                        <TypographyPoppins
                            text={"to access your account"}
                            customStyle={"!text-base !font-light !lowercase"}
                        />
                    </Link>

                    <Link
                        onClick={() => setOpen(false)}
                        testid={`header-profile-menu-signup`}
                        href={signupLink}
                        prefetch
                        className="flex gap-x-1"
                    >
                        <TypographyPoppins
                            text={"Sign Up"}
                            customStyle={"!text-base !font-medium !capitalize !underline"}
                        />
                        <TypographyPoppins
                            text={"for styling and exclusives"}
                            customStyle={"!text-base !font-light !lowercase"}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProfileMenuLoginSignup;
